import { MOBILE_VIEWPORT_MEDIA_QUERY } from "../../utils/viewportBreakpoints";

const TOOLBAR_ICON_CLASS = "h-[18px] w-[18px]";
const MOBILE_TOOLBAR_MEDIA_QUERY = MOBILE_VIEWPORT_MEDIA_QUERY;
const VIEWPORT_TOOLBAR_POSITION_KEY = "critter.viewportToolbar.position.v1";
const VIEWPORT_TOOLBAR_GRIP_LEFT_OFFSET = 22;

function clampViewportToolbarPosition(position, rect) {
  if (typeof window === "undefined") return position;
  const margin = 12;
  const mainPanelRect = document.querySelector(".main-menu-panel")?.getBoundingClientRect();
  const mainPanelRight =
    mainPanelRect && mainPanelRect.right > margin ? mainPanelRect.right + margin : margin;
  const minLeft = Math.max(margin + VIEWPORT_TOOLBAR_GRIP_LEFT_OFFSET, mainPanelRight);
  const maxLeft = Math.max(minLeft, window.innerWidth - rect.width - margin);
  const maxTop = Math.max(margin, window.innerHeight - rect.height - margin);
  return {
    left: Math.min(Math.max(position.left, minLeft), maxLeft),
    top: Math.min(Math.max(position.top, margin), maxTop),
  };
}

export {
  MOBILE_TOOLBAR_MEDIA_QUERY,
  TOOLBAR_ICON_CLASS,
  VIEWPORT_TOOLBAR_POSITION_KEY,
  clampViewportToolbarPosition,
};
